import * as THREE from 'three';
import AssetManager from '../../managers/AssetManager';
import { applySkinToObject, getTextureForSkin } from '../../utils/skin';
import { IActor, IAimable } from '../types';

export default class TankActor implements IActor, IAimable {
  private scene: THREE.Scene;
  private collidables: THREE.Object3D[];
  private userId: string;
  private name: string;
  private color: string;
  private root: THREE.Object3D;
  private turret: THREE.Object3D | null = null;
  private cannon: THREE.Object3D | null = null;

  constructor(scene: THREE.Scene, collidables: THREE.Object3D[], name: string, userId: string, color: string) {
    this.scene = scene;
    this.collidables = collidables;
    this.userId = userId;
    this.name = name;
    this.color = color;

    // Instantiate model
    const model = AssetManager.getModel('tankModel') as THREE.Object3D;
    this.root = model;
    this.root.traverse((child: THREE.Object3D) => {
      if (child.name === 'Main_Gun') this.cannon = child;
      if (child.name === 'TopPart') {
        this.turret = child;
        (this.turret as any).userData.info = {
          name: 'tankTurret',
          description: 'A 3D tank turret.',
          collision: true,
        };
      }
      if ((child as any).isMesh) {
        const mesh = child as THREE.Mesh;
        const mat = (mesh.material as THREE.Material).clone();
        mesh.material = mat;
        mesh.castShadow = true;
      }
    });

    (this.root as any).userData.info = {
      objectName: 'enemyTankModel',
      playerId: this.userId,
      name: this.name,
      color: this.color,
      isEnemy: true,
      description: 'enemy character',
      collision: true,
    };

    this.root.scale.set(0.01, 0.01, 0.01);
    this.root.position.set(0, 1, 0);

    // Apply initial skin
    if (this.color) this.setSkin(this.color);

    this.scene.add(this.root);
  }

  getRoot(): THREE.Object3D {
    return this.root;
  }

  setSkin(skinName: string): void {
    const texture = getTextureForSkin(skinName);
    if (!texture) return;
    applySkinToObject(this.root, texture);
  }

  setPosition(pos: THREE.Vector3): void {
    this.root.position.copy(pos);
  }

  setRotation(quat: THREE.Quaternion): void {
    this.root.quaternion.copy(quat);
  }

  setTurretRotationX(rotationX: number): void {
    if (this.turret) (this.turret as any).rotation.x = rotationX;
  }

  receiveDamage(_damage: number, _byId: string): void {
    // Remote actors may not handle damage locally; kept for interface completeness
  }

  dispose(): void {
    if (this.root) {
      const index = this.collidables.indexOf(this.root);
      if (index > -1) this.collidables.splice(index, 1);
      this.scene.remove(this.root);
    }
    this.turret = null;
    this.cannon = null;
    // Geometry/material disposal is managed by AssetManager clear/disposeScene in this app
  }
}

